import * as React from "react"

const Logout = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m8.8 9-1.65 1.65-.36.35.71.7.35-.35 2.5-2.5.36-.35-.36-.35-2.5-2.5-.35-.36-.7.71.35.35L8.79 8H2.5v1h6.3Zm4.7-5.5v10h-1v-10h1Z" />
  </svg>
)

export default Logout
